// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box{width:23.4375rem!important;height:11.354167rem!important;background:#fff!important;border-radius:.520833rem!important}.el-message-box__header{background:#f8f8f8}.el-message-box__title{font-size:.833333rem;font-weight:400;color:#666}.el-message-box__content{padding:2.552083rem 6.197917rem;color:#606266;font-size:.729167rem}.el-message-box__btns .el-button--primary{background:linear-gradient(90deg,#2079fb,#4cb2fc)}", ""]);
// Exports
module.exports = exports;
